/**
 * Actions
 */
import * as ActionTypes from '../constants/ActionTypes';
import * as AlertTypes from '../constants/AlertTypes';

export const createAlert = (err, timeout) => {
  const alert = {
    type: ActionTypes.CREATE_ALERT,
    alertType: err.statusCode === 500 ? AlertTypes.DANGER : AlertTypes.WARNING,
    text: err.message,
    timeout,
  };
  const { warningMsg } = err;
  if (alert.alertType === AlertTypes.WARNING && warningMsg) {
    alert.text = warningMsg;
  }
  return alert;
};

export const createSuccessAlert = (text, timeout) => ({
  type: ActionTypes.CREATE_ALERT,
  alertType: AlertTypes.SUCCESS,
  text,
  timeout,
});

export const createDangerAlert = (text, timeout) => ({
  type: ActionTypes.CREATE_ALERT,
  alertType: AlertTypes.DANGER,
  text,
  timeout,
});

export const createWarningAlert = (text, timeout) => ({
  type: ActionTypes.CREATE_ALERT,
  alertType: AlertTypes.WARNING,
  text,
  timeout,
});

export const createInfoAlert = (text, timeout) => ({
  type: ActionTypes.CREATE_ALERT,
  alertType: AlertTypes.INFO,
  text,
  timeout,
});

export const dismissAlert = alertId => ({
  type: ActionTypes.DISMISS_ALERT,
  alertId,
});

export const dismissLastAlert = () => ({
  type: ActionTypes.DISMISS_LAST_ALERT,
});



// WEBPACK FOOTER //
// ./src/actions/ActionCreators.js